import script from "./ElementOutline.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementOutline.vue?vue&type=script&lang=ts&setup=true"

import "./ElementOutline.vue?vue&type=style&index=0&id=49642f50&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49642f50"]])

export default __exports__